import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";

function TownhouseSVG() {
  // Decorative Georgian townhouse line-art in champagne gold on navy.
  return (
    <svg
      data-testid="hero-illustration"
      viewBox="0 0 380 560"
      fill="none"
      stroke="#C9A84C"
      strokeWidth="1.2"
      className="w-full h-full max-h-[640px]"
      aria-hidden="true"
    >
      <rect x="40" y="120" width="300" height="420" stroke="rgba(201,168,76,0.55)" />
      <path d="M30 120 L190 40 L350 120" stroke="rgba(201,168,76,0.7)" />
      <path d="M70 120 V540" stroke="rgba(201,168,76,0.25)" />
      <path d="M310 120 V540" stroke="rgba(201,168,76,0.25)" />
      {[180, 260, 340, 420].map((y) => (
        <g key={y}>
          <rect x="80" y={y} width="60" height="60" stroke="rgba(201,168,76,0.7)" />
          <rect x="160" y={y} width="60" height="60" stroke="rgba(201,168,76,0.7)" />
          <rect x="240" y={y} width="60" height="60" stroke="rgba(201,168,76,0.7)" />
          <line x1="110" y1={y} x2="110" y2={y + 60} stroke="rgba(201,168,76,0.4)" />
          <line x1="190" y1={y} x2="190" y2={y + 60} stroke="rgba(201,168,76,0.4)" />
          <line x1="270" y1={y} x2="270" y2={y + 60} stroke="rgba(201,168,76,0.4)" />
          <line x1="80" y1={y + 30} x2="140" y2={y + 30} stroke="rgba(201,168,76,0.4)" />
          <line x1="160" y1={y + 30} x2="220" y2={y + 30} stroke="rgba(201,168,76,0.4)" />
          <line x1="240" y1={y + 30} x2="300" y2={y + 30} stroke="rgba(201,168,76,0.4)" />
        </g>
      ))}
      {/* Door */}
      <rect x="160" y="470" width="60" height="70" stroke="#C9A84C" />
      <path d="M160 510 Q190 480 220 510" stroke="#C9A84C" />
      <line x1="190" y1="480" x2="190" y2="540" stroke="rgba(201,168,76,0.6)" />
      {/* Steps */}
      <line x1="140" y1="548" x2="240" y2="548" stroke="#C9A84C" />
      <line x1="130" y1="556" x2="250" y2="556" stroke="#C9A84C" />
      {/* Roof detail */}
      <line x1="40" y1="120" x2="340" y2="120" stroke="#C9A84C" />
      <line x1="40" y1="128" x2="340" y2="128" stroke="rgba(201,168,76,0.4)" />
      {/* Cornice/crest */}
      <path d="M170 80 L190 60 L210 80" stroke="#C9A84C" />
    </svg>
  );
}

export function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-[var(--navy)] text-[var(--ivory)] grain-overlay min-h-screen flex items-center pt-28 pb-20 overflow-hidden"
    >
      {/* faint vertical rule */}
      <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-[rgba(201,168,76,0.10)]" />
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 w-full grid lg:grid-cols-[1.1fr_0.9fr] gap-16 items-center">
        <div className="reveal">
          <h1
            data-testid="hero-headline"
            className="font-display text-[2.75rem] sm:text-5xl lg:text-[5rem] leading-[1.02] tracking-tight"
          >
            Building Wealth
            <br />
            Through Carefully Selected
            <br />
            <span className="italic text-[var(--gold)]">Property Investments.</span>
          </h1>
          <p className="mt-8 text-[1.05rem] lg:text-[1.15rem] text-[var(--ivory)]/75 max-w-xl leading-relaxed">
            We source carefully selected Buy-to-Let investment opportunities across
            East London and Stoke-on-Trent, helping investors build long-term wealth
            through research-led property investments.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-5">
            <a href="#guide" data-testid="hero-cta-primary" className="btn-gold">
              Download the Free Investor Guide
              <ArrowRight size={18} />
            </a>
            <a
              href="#strategy"
              data-testid="hero-cta-secondary"
              className="text-[0.85rem] tracking-[0.18em] uppercase text-[var(--ivory)]/80 hover:text-[var(--gold)] transition-colors"
            >
              Explore Our Strategy →
            </a>
          </div>
        </div>
        <div className="reveal hidden lg:flex items-center justify-center">
          <TownhouseSVG />
        </div>
      </div>
      <a
        href="#trust"
        aria-label="Scroll to next section"
        className="absolute left-1/2 -translate-x-1/2 bottom-8 text-[var(--gold)] bounce"
      >
        <ChevronDown size={28} />
      </a>
    </section>
  );
}
